module.exports = __webpack_public_path__ + "img/plane-up-slash.b6685fdd.svg";